// libs
import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// defs
import type { EMIWidgetTotalPayableItem } from "@payment-client/interfaces/Checkout";

// styled
import { Cell, Row } from "./styled";

// hooks
import { useEffectOnce } from "@swiggy-private/core-ui";

interface IProps {
    totalPayable: EMIWidgetTotalPayableItem;
    captureImpression: (payload: any) => void;
}

const TotalPayableItem = ({ totalPayable, captureImpression }: IProps) => {
    useEffectOnce(() => {
        captureImpression(totalPayable.analytics);
    });

    return (
        <Row>
            {totalPayable.items.map((item) => {
                const { details, subtextDetails } = item.displayContent;
                const textContent = details?.[0]?.text?.content || "";
                const subtextContent = subtextDetails?.details?.[0]?.text?.content;

                return (
                    <Cell key={textContent}>
                        <Text variant="V2.body2.neutral.bold" color="text_High_Emphasis">
                            {textContent}
                        </Text>
                        <Text variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                            {subtextContent}
                        </Text>
                    </Cell>
                );
            })}
        </Row>
    );
};

export default memo(TotalPayableItem);
